import moment from 'moment/moment';

import {
  FROM_ORIGIN,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
  THIS_MONTH,
} from '@/constants';

const today = () => new Date();

export const getLastSevenDays = () => {
  const start = moment(new Date())
    .subtract(6, 'days')
    .toDate();

  return {
    start,
    end: today(),
  };
};

export const getToday = () => {
  const date = new Date();

  return { start: date, end: date };
};

const getThisMonth = () => {
  const start = moment(getToday())
    .startOf('month')
    .toDate();

  return { start, end: today() };
};

const getLastThirtyDays = () => {
  const start = moment(new Date())
    .subtract(29, 'days')
    .toDate();

  return {
    start,
    end: today(),
  };
};

const getFromOrigin = originDate => ({
  start: originDate,
  end: today(),
});

const getDateInterval = (firstAvailableDate = null) => option => {
  const dateFunctionMapping = {
    [THIS_MONTH]: getThisMonth,
    [LAST_SEVEN_DAYS]: getLastSevenDays,
    [LAST_THIRTY_DAYS]: getLastThirtyDays,
    [FROM_ORIGIN]: getFromOrigin,
  };

  return dateFunctionMapping[option](firstAvailableDate);
};

export default getDateInterval;

export const isFirstDay = firstAvailableDate =>
  moment(firstAvailableDate).isSame(moment());
